/*
 * Lista VIP · Black November — formulário de inscrição.
 *
 * Envia nome, e-mail e (com consentimento) WhatsApp para o Klaviyo pela Client API,
 * a mesma que os formulários do próprio Klaviyo usam. Só a chave pública entra aqui.
 * Referência: POST https://a.klaviyo.com/client/subscriptions (revisão 2026-07-15).
 *
 * Sem dependências. Vai igual para a Shopify (asset ou {% javascript %} da seção).
 * A configuração vem dos data-atributos de cada <form data-vip-form>. Funciona com mais de um formulário
 * na página (landing page e pop-up). Depois da inscrição:
 *   - data-success="redirect" (padrão): vai para data-success-url;
 *   - data-success="inline": fica na página e dispara o evento "vip:inscrita" no formulário (o pop-up usa).
 * data-origin grava de onde veio a inscrição (landing-page, pop-up).
 */
(function () {
  'use strict';

  const KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions';
  const KLAVIYO_REVISION = '2026-07-15';
  const DONE_FLAG = 'vip_bn26_inscrita';
  const BRAZIL_CODE = '55';
  const MIN_INTERNATIONAL_DIGITS = 8;
  const MAX_INTERNATIONAL_DIGITS = 15;

  const forms = document.querySelectorAll('[data-vip-form]');
  for (let f = 0; f < forms.length; f++) setup(forms[f]);

  function setup(form) {
  if (form.hasAttribute('data-vip-ready')) return;
  const cfg = form.dataset;
  const el = {
    fields: form.querySelector('[data-vip-fields]'),
    closed: form.querySelector('[data-vip-closed]'),
    nome: form.elements.nome,
    email: form.elements.email,
    whatsapp: form.elements.whatsapp,
    consent: form.elements.whatsapp_consent,
    trap: form.elements.website,
    check: form.querySelector('[data-vip-check]'),
    submit: form.querySelector('[data-vip-submit]'),
    submitLabel: form.querySelector('[data-vip-submit-label]'),
    status: form.querySelector('[data-vip-status]'),
    emailHint: form.querySelector('[data-vip-email-hint]'),
    emailFix: form.querySelector('[data-vip-email-fix]'),
  };
  const whatsappRequired = cfg.whatsapp === 'obrigatorio';
  const isLocal = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname) || location.protocol === 'file:';
  const loadedAt = Date.now();
  let sending = false;

  const TEXT = {
    nome: 'Digite seu nome.',
    email: 'Digite um e-mail válido.',
    whatsapp: 'Digite o WhatsApp com DDD. Exemplo: (11) 99999-9999. Fora do Brasil, comece com + e o código do país.',
    whatsappParaAvisos: 'Para receber os avisos, digite seu WhatsApp.',
    whatsappObrigatorio: 'Digite seu WhatsApp com DDD.',
    falha: 'Não foi possível concluir a inscrição agora. Tente de novo em instantes.',
    semConexao: 'Parece que a conexão caiu. Confira a internet e tente de novo.',
    enviando: 'Enviando…',
  };

  /* ── Fechamento automático da lista ─────────────────────────────────── */

  function closeIfExpired() {
    const closesAt = cfg.closesAt ? Date.parse(cfg.closesAt) : NaN;
    if (isNaN(closesAt) || Date.now() < closesAt) return false;
    if (el.fields) el.fields.hidden = true;
    if (el.closed) el.closed.hidden = false;
    return true;
  }
  if (closeIfExpired()) return;

  /* ── Utilidades ─────────────────────────────────────────────────────── */

  function onlyDigits(value) {
    return String(value || '').replace(/\D+/g, '');
  }

  // Devolve os 10 ou 11 dígitos nacionais (DDD + número), ou '' se não for um número válido.
  function nationalPhone(digits) {
    let d = digits.replace(/^0+/, ''); // 0 na frente do DDD
    if (d.length > 11 && d.indexOf(BRAZIL_CODE) === 0) d = d.slice(2).replace(/^0+/, ''); // veio com o 55 do Brasil
    if (d.length !== 10 && d.length !== 11) return '';
    if (!/^[1-9][1-9]/.test(d)) return ''; // DDD não tem zero
    if (d.length === 11 && d.charAt(2) !== '9') return ''; // celular começa com 9
    return d;
  }

  function startsWithCountryCode(value) {
    return /^\s*(\+|00)/.test(String(value || ''));
  }

  function foreignPhone(digits) {
    if (digits.length < MIN_INTERNATIONAL_DIGITS || digits.length > MAX_INTERNATIONAL_DIGITS) return '';
    if (digits.charAt(0) === '0') return '';
    return '+' + digits;
  }

  function brazilianPhone(digits) {
    const national = nationalPhone(digits);
    return national ? '+' + BRAZIL_CODE + national : '';
  }

  function withoutTrunkZeroMark(value) {
    return String(value || '').replace(/\(0\)/g, '');
  }

  function e164Phone(value) {
    const typed = withoutTrunkZeroMark(value);
    if (!startsWithCountryCode(typed)) return brazilianPhone(onlyDigits(typed));
    const digits = onlyDigits(typed).replace(/^00/, '');
    return digits.indexOf(BRAZIL_CODE) === 0 ? brazilianPhone(digits) : foreignPhone(digits);
  }

  function formatPhone(value) {
    const phone = e164Phone(value);
    if (phone.indexOf('+' + BRAZIL_CODE) !== 0) return value;
    const d = phone.slice(BRAZIL_CODE.length + 1);
    return d.length === 11
      ? '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7)
      : '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  // Nome digitado todo em minúsculas ou todo em maiúsculas vira "Maria Clara da Silva",
  // para as mensagens que usam o nome saírem bem escritas. Nome já misto fica como veio.
  function tidyName(value) {
    if (value !== value.toLowerCase() && value !== value.toUpperCase()) return value;
    const small = { da: 1, de: 1, do: 1, das: 1, dos: 1, e: 1 };
    return value
      .toLowerCase()
      .split(' ')
      .map(function (word, index) {
        if (index > 0 && small[word]) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  // Sugere a correção dos erros de digitação mais comuns no domínio do e-mail.
  // O acesso chega só por e-mail, então um endereço errado perde a cliente.
  const DOMAINS = [
    'gmail.com', 'hotmail.com', 'outlook.com', 'icloud.com', 'yahoo.com.br', 'yahoo.com',
    'uol.com.br', 'terra.com.br', 'live.com', 'bol.com.br', 'me.com', 'msn.com',
  ];
  function distance(a, b) {
    let prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }
  function suggestEmail(value) {
    const at = value.lastIndexOf('@');
    if (at < 1) return '';
    const domain = value.slice(at + 1).toLowerCase();
    if (!domain || DOMAINS.indexOf(domain) !== -1) return '';
    let best = '', bestDist = 3;
    for (let i = 0; i < DOMAINS.length; i++) {
      const dist = distance(domain, DOMAINS[i]);
      if (dist < bestDist) { bestDist = dist; best = DOMAINS[i]; }
    }
    return best ? value.slice(0, at + 1) + best : '';
  }

  function setError(name, message) {
    const input = el[name];
    const box = form.querySelector('[data-vip-error="' + name + '"]');
    if (input) {
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    if (box) {
      box.textContent = message || '';
      box.hidden = !message;
    }
  }

  function setStatus(message) {
    if (!el.status) return;
    el.status.textContent = message || '';
    el.status.hidden = !message;
  }

  function setSending(on) {
    sending = on;
    if (!el.submit) return;
    el.submit.disabled = on;
    el.submit.setAttribute('aria-busy', on ? 'true' : 'false');
    if (el.submitLabel) {
      if (on) {
        el.submitLabel.dataset.original = el.submitLabel.textContent;
        el.submitLabel.textContent = TEXT.enviando;
      } else if (el.submitLabel.dataset.original) {
        el.submitLabel.textContent = el.submitLabel.dataset.original;
      }
    }
  }

  // Parâmetros de campanha da URL (utm_* e fbclid), para saber de qual anúncio a pessoa veio.
  function campaignParams() {
    const out = {};
    let params;
    try { params = new URLSearchParams(location.search); } catch { return out; }
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      const value = params.get(key);
      if (value) out['vip_bn26_' + key] = value.slice(0, 120);
    });
    if (params.get('fbclid')) out.vip_bn26_veio_de_anuncio_meta = true;
    return out;
  }

  /* ── Comportamento dos campos ───────────────────────────────────────── */

  ['nome', 'email', 'whatsapp'].forEach(function (name) {
    if (!el[name]) return;
    el[name].addEventListener('input', function () {
      setError(name, '');
      setStatus('');
    });
  });

  if (el.email) {
    el.email.addEventListener('blur', function () {
      const value = el.email.value.trim();
      const fix = validEmail(value) ? suggestEmail(value) : '';
      if (el.emailHint && el.emailFix) {
        el.emailFix.textContent = fix;
        el.emailHint.hidden = !fix;
      }
    });
    el.email.addEventListener('input', function () {
      if (el.emailHint) el.emailHint.hidden = true;
    });
  }
  if (el.emailFix) {
    el.emailFix.addEventListener('click', function () {
      el.email.value = el.emailFix.textContent;
      el.emailHint.hidden = true;
      setError('email', '');
      el.email.focus();
    });
  }

  function refreshConsentNudge() {
    if (!el.check || !el.consent || !el.whatsapp) return;
    const asking = !!e164Phone(el.whatsapp.value) && !el.consent.checked;
    el.check.classList.toggle('is-asking', asking);
  }
  if (el.whatsapp) {
    el.whatsapp.addEventListener('input', refreshConsentNudge);
    el.whatsapp.addEventListener('blur', function () {
      el.whatsapp.value = formatPhone(el.whatsapp.value);
      refreshConsentNudge();
    });
  }
  if (el.consent) {
    el.consent.addEventListener('change', function () {
      setError('whatsapp', '');
      refreshConsentNudge();
    });
  }

  /* ── Envio ──────────────────────────────────────────────────────────── */

  function readForm() {
    const nome = tidyName(el.nome.value.replace(/\s+/g, ' ').trim());
    const email = el.email.value.trim().toLowerCase();
    const whatsappRaw = el.whatsapp ? el.whatsapp.value.trim() : '';
    const phone = e164Phone(whatsappRaw);
    const consent = !!(el.consent && el.consent.checked);
    const errors = {};

    if (nome.length < 2) errors.nome = TEXT.nome;
    if (!validEmail(email)) errors.email = TEXT.email;
    if (whatsappRaw && !phone) errors.whatsapp = TEXT.whatsapp;
    else if (!whatsappRaw && whatsappRequired) errors.whatsapp = TEXT.whatsappObrigatorio;
    else if (!whatsappRaw && consent) errors.whatsapp = TEXT.whatsappParaAvisos;

    return { nome: nome, email: email, phone: phone, consent: consent, errors: errors };
  }

  function buildPayload(data, listId, withPhone) {
    const space = data.nome.indexOf(' ');
    const firstName = space === -1 ? data.nome : data.nome.slice(0, space);
    const lastName = space === -1 ? '' : data.nome.slice(space + 1);
    // O número vai para o perfil sempre que for válido; a inscrição no WhatsApp, só com o consentimento.
    const sendPhone = withPhone && data.phone;
    const subscribeWhatsapp = sendPhone && data.consent;

    const properties = campaignParams();
    properties.vip_bn26 = true;
    properties.vip_bn26_inscrita_em = new Date().toISOString();
    properties.vip_bn26_origem = cfg.origin || 'landing-page';
    properties.vip_bn26_aceitou_whatsapp = !!(data.consent && data.phone);
    // Se o envio com telefone falhar, o número fica guardado aqui para não perder o contato.
    if (data.phone && !sendPhone) properties.vip_bn26_whatsapp_informado = data.phone;

    const subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (subscribeWhatsapp) subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };

    const attributes = {
      email: data.email,
      first_name: firstName,
      locale: 'pt-BR',
      properties: properties,
      subscriptions: subscriptions,
    };
    if (lastName) attributes.last_name = lastName;
    if (sendPhone) attributes.phone_number = data.phone;

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Lista VIP Black November 2026',
          profile: { data: { type: 'profile', attributes: attributes } },
        },
        relationships: { list: { data: { type: 'list', id: listId } } },
      },
    };
  }

  function post(payload) {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = controller ? setTimeout(function () { controller.abort(); }, 12000) : null;
    return fetch(KLAVIYO_URL + '?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        accept: 'application/vnd.api+json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    }).then(
      function (response) { if (timer) clearTimeout(timer); return response; },
      function (error) { if (timer) clearTimeout(timer); throw error; }
    );
  }

  function subscribe(data) {
    const listId = cfg.listId;

    // Sem lista configurada: só simula o envio na prévia local, para testar a tela.
    if (!listId) {
      if (!isLocal) return Promise.reject(new Error('Lista do Klaviyo não configurada (data-list-id).'));
      console.info('[lista VIP] modo de teste — nada foi enviado ao Klaviyo:', buildPayload(data, 'LISTA_NAO_CONFIGURADA', true));
      return new Promise(function (resolve) { setTimeout(resolve, 600); });
    }

    return post(buildPayload(data, listId, true))
      .then(function (response) {
        if (response.ok) return response;
        // O Klaviyo recusa o pedido inteiro se não aceitar o telefone.
        // Tenta de novo só com o e-mail para não perder a inscrição.
        if (response.status >= 400 && response.status < 500 && data.phone) {
          return post(buildPayload(data, listId, false));
        }
        return response;
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo respondeu ' + response.status);
        // Segunda lista, só de quem aceitou WhatsApp (opcional). Se falhar, a inscrição principal já valeu.
        if (cfg.whatsappListId && data.consent && data.phone) {
          return post(buildPayload(data, cfg.whatsappListId, true)).then(null, function () {});
        }
      });
  }

  // Identifica a pessoa no script do próprio Klaviyo (o da loja). É ele que registra o IP do navegador,
  // e é do IP que o Klaviyo tira a localização (cidade e estado) do perfil: a Client API sozinha não grava.
  // Devolve uma promessa que resolve quando o Klaviyo confirmar ou em até 1,5 s, o que vier antes.
  function identifyOnsite(data) {
    const kl = window.klaviyo;
    if (!kl || typeof kl.identify !== 'function') return Promise.resolve();
    const space = data.nome.indexOf(' ');
    const who = { email: data.email, first_name: space === -1 ? data.nome : data.nome.slice(0, space) };
    if (space !== -1) who.last_name = data.nome.slice(space + 1);
    if (data.phone) who.phone_number = data.phone;
    return new Promise(function (resolve) {
      const timer = setTimeout(resolve, 1500);
      const done = function () { clearTimeout(timer); resolve(); };
      try {
        const result = kl.identify(who, done);
        if (result && typeof result.then === 'function') result.then(done, done);
      } catch { done(); }
    });
  }

  // Avisa as ferramentas de medição que já estiverem na página. Nenhuma é obrigatória.
  function track() {
    try {
      sessionStorage.setItem(DONE_FLAG, '1');
    } catch {}
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'lista_vip_inscricao', lista: 'black-november-2026' });
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('lista_vip_inscricao', { lista: 'black-november-2026' });
      }
    } catch {}
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (sending) return;
    if (closeIfExpired()) return;

    const data = readForm();
    setStatus('');
    ['nome', 'email', 'whatsapp'].forEach(function (name) { setError(name, data.errors[name] || ''); });

    const firstInvalid = ['nome', 'email', 'whatsapp'].filter(function (name) { return data.errors[name]; })[0];
    if (firstInvalid) {
      el[firstInvalid].focus();
      return;
    }

    // Robôs preenchem o campo-isca ou enviam rápido demais. Nada é enviado ao Klaviyo.
    if ((el.trap && el.trap.value) || Date.now() - loadedAt < 1500) {
      setStatus(TEXT.falha);
      return;
    }

    setSending(true);
    subscribe(data).then(
      function () {
        track();
        const located = identifyOnsite(data);
        if (cfg.success === 'inline') {
          setSending(false);
          form.dispatchEvent(new CustomEvent('vip:inscrita', { bubbles: true, detail: { nome: data.nome, email: data.email } }));
          return;
        }
        const target = cfg.successUrl || '/';
        located.then(function () { window.location.assign(target); });
      },
      function (error) {
        setSending(false);
        setStatus(navigator.onLine === false ? TEXT.semConexao : TEXT.falha);
        if (window.console) console.error('[lista VIP]', error);
      }
    );
  });

  // Voltou pelo botão "voltar" do navegador: libera o botão de novo.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) setSending(false);
  });

  form.setAttribute('data-vip-ready', '');
  }
})();
